module.exports = __webpack_public_path__ + "img/mail.ae0b1611.svg";